import Summary from './Summary'

const UserEntry = () => {
  return <Summary type={'user'} />
}

export default UserEntry
